import _ from 'lodash';
import { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'common/components/ModalComponent';
import { ORDER_TYPES } from 'common/constants/index';
import ErrorMesssage from 'common/components/ErrorMesssage';
import MoneyDisplay from 'common/components/MoneyDisplay';
import { QuantOrderType } from 'ui/run/RunForm/components/index';
import Multiplier from './Multiplier';
import FreeTrialInfo from './freeTrialInfo';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import AlgoverseDeploymentCostAlert from 'v3/common/components/Algoverse/DeploymentCostAlert';

const propTypes = {
  multiplier: PropTypes.number,
  onChangeMultiplier: PropTypes.func.isRequired,
  onCreateRun: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  selectedOrderType: PropTypes.string.isRequired,
  onChangeSelectedOrderType: PropTypes.func.isRequired,
  marginAmount: PropTypes.number.isRequired,
  isMinifiedPage: PropTypes.bool.isRequired,
  initialFreeTrialDays: PropTypes.number,
  purchaseAmount: PropTypes.number,
  isFreeTrialAvailable: PropTypes.bool,
  isPremiumQuantPlan: PropTypes.bool,
};
const defaultProps = {
  multiplier: 1,
  initialFreeTrialDays: 0,
  purchaseAmount: null,
  isFreeTrialAvailable: false,
  isPremiumQuantPlan: false,
};

const MULTIPLIER_LIMIT = 200;

const StrategyConfirmationModal = ({
  multiplier,
  onChangeMultiplier,
  onCreateRun,
  onCloseModal,
  selectedOrderType,
  onChangeSelectedOrderType,
  marginAmount,
  isMinifiedPage,
  initialFreeTrialDays,
  purchaseAmount,
  isFreeTrialAvailable,
  isPremiumQuantPlan,
}) => {
  const [isAgreed] = useState(true);

  const allowedOrderTypes = _.filter(ORDER_TYPES, (type) =>  ApplicationDomainUtility.eligibleOrderType().includes(type.value)); 

  const orderTypes = _.omit(allowedOrderTypes, isMinifiedPage ? ['oneClick', 'paper'] : ['oneClick']);
  const isInValidMultiplier = multiplier > MULTIPLIER_LIMIT;


  return (
    <Modal
      onSave={onCreateRun}
      onClose={onCloseModal}
      size="md"
      okBtnTitle="Deploy Strategy"
      isOkBtnDisabled={!isAgreed || isInValidMultiplier}
      btnClassName="btn-success btn-sm"
    >
      <>
        <div className="text-center mb-2">
          <div
            className="alert-info border-radius-14 mb-2 object-fit-cover text-center m-auto width-fit-content p-2"
            role="alert "
          >
            <span>
              <i className="fa-regular fa-circle-info tx-30" />
            </span>
          </div>
          <h4 className="font-weight-medium mb-3 mt-2">Confirmation</h4>
          <p>Number of lots</p>
          <div className="my-2">
            <Multiplier
              multiplier={multiplier}
              onChangeMultiplier={onChangeMultiplier}
              maxMultiplier={MULTIPLIER_LIMIT}
            />
          </div>
          <div className="my-2 d-flex align-items-center justify-content-center gap-1">
            Margin Required:
            <b>
              <MoneyDisplay>{multiplier ? marginAmount * Math.abs(multiplier) : marginAmount}</MoneyDisplay>
            </b>
          </div>
          {isInValidMultiplier && (
            <ErrorMesssage
              error={{ message: `*You are exceed, Limit for multiplier is upto ${MULTIPLIER_LIMIT}` }}
            />
          )}
          <AlgoverseDeploymentCostAlert isPremium={isPremiumQuantPlan} variant="alert" />
          {window.isAdmin && (
            <QuantOrderType
              orderType={selectedOrderType}
              onOrderTypeChange={onChangeSelectedOrderType}
              orderTypes={orderTypes}
              orderTypeParentClassName="d-flex gap-15 mt-2 justify-content-center align-items-center"
              isShowOrderTypeLabel={false}
            />
          )}
          <div className="tx-12 mt-2 d-none">
            The past backtesting performance of the strategy is not necessarily indicative of future
            performance of the strategy and trading is subject to market risks
          </div>

          {isFreeTrialAvailable && (
            <FreeTrialInfo
              initialFreeTrialDays={initialFreeTrialDays}
              purchaseAmount={purchaseAmount}
              isStrategyConfirmationModel
            />
          )}
        </div>
      </>
    </Modal>
  );
};

StrategyConfirmationModal.propTypes = propTypes;
StrategyConfirmationModal.defaultProps = defaultProps;

export default StrategyConfirmationModal;
